var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-x-y take-max-height"},[_c('section',{staticClass:"has-text-centered"},[(_vm.code)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.code))]):_vm._e(),(_vm.message)?_c('h3',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }